module.exports = __webpack_public_path__ + "static/img/background_defult.2d69b58a.png";